import { render, staticRenderFns } from "./news_small.vue?vue&type=template&id=39448b9b&scoped=true&"
import script from "./news_small.vue?vue&type=script&lang=js&"
export * from "./news_small.vue?vue&type=script&lang=js&"
import style0 from "./news_small.vue?vue&type=style&index=0&id=39448b9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39448b9b",
  null
  
)

export default component.exports